<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="sales" title="orders" />
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card pt-3 pb-3" v-for="item in listData" :key="item.host">

            <TableOrders :site="item.host"></TableOrders>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import TableOrders from "./TableOrders.vue";
import Cookies from 'js-cookie';
export default {
  components: { TableOrders },
  data() {
    return {
      listData: []
    };
  },
  async mounted() {
    this.listData = await this.getStoresData();
  },
  methods: {
    async getStoresData() {
      let listData = [];
      var ProductRef = await firebase.firestore().collection("Sites")
        .where("host", "==", this.getStore())
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listData.push(
              doc.data()
            );
          });
        });
      return listData;

    },
    getStore() {
      const host = Cookies.get('hostCookie');
      if (host) {
        return host;
      } else {
        this.$router.push('/dashboard/default');
      }
    },
  }
}
</script>

<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>